import React from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import $ from 'jquery';
import HmAjax from '../../util/HmAjax';
import LoggedInPage from '../../views/core/LoggedInPage';
import subtopicDefaultBgImg from '../../images/icons/practice_icon.png';
import practiceBgImg from '../../images/icons/recomnd_icon.png';
import reportBgImg from '../../images/icons/report_icon.png';
import bottomPointsIcon from '../../images/icons/points_icon.png';
import proficiencyReportIcon from '../../images/icons/report-proficiency.png';
import practiceReportIcon from '../../images/icons/report-practice.png';
import completedTickImg from '../../images/icons/tick_icon_grey.png';
import topicLessonIconImg from '../../images/icons/topic_lesson_icon.png';
import LessonIconImg from '../../images/icons/lesson_icon.png';
import ratingDefaultIcon from '../../images/icons/emojis/rating_default.png';

import ratingBadIcon from '../../images/icons/emojis/bad.gif';
import ratingGoodIcon from '../../images/icons/emojis/good.gif';
import ratingLoveitIcon from '../../images/icons/emojis/loveit.gif';
import ratingNormalIcon from '../../images/icons/emojis/normal.gif';
import ratingVerybadIcon from '../../images/icons/emojis/verybad.gif';

import ratingBadIconSmall from '../../images/icons/emojis/bad_small.png';
import ratingGoodIconSmall from '../../images/icons/emojis/good_small.png';
import ratingLoveitIconSmall from '../../images/icons/emojis/loveit_small.png';
import ratingNormalIconSmall from '../../images/icons/emojis/normal_small.png';
import ratingVerybadIconSmall from '../../images/icons/emojis/verybad_small.png';
import HmEventRegistry from '../../model/HmEventRegistry';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactHtmlParser from 'react-html-parser';
var imagePath = "/lesson/get_lesson_thumbnails?image=";

class SubTopicComponent extends LoggedInPage {
	
  constructor(props) {
  	super(props);  
  	
    this.state = {
      popoverOpen: false,     
      selectedEmoji: parseInt(this.props.subtopic.rating),
      noOfRetakesAvailable : this.props.subtopic.noOfRetakesAvailable
    };
    
    this.selectedRate = parseInt(this.props.subtopic.rating);
  	this.onSubTopicStart = this.onSubTopicStart.bind(this);
  	this.onSubTopicStartLessons = this.onSubTopicStartLessons.bind(this);
  	this.onSubTopicStartCP = this.onSubTopicStartCP.bind(this);
  	this.onSubTopicStartPT = this.onSubTopicStartPT.bind(this);
  	this.getDropDownItems = this.getDropDownItems.bind(this);
  	this.toggle = this.toggle.bind(this);
  	this.selectRating = this.selectRating.bind(this);
  	
  	this.handleMouseOver = this.handleMouseOver.bind(this);
	this.handleMouseOut = this.handleMouseOut.bind(this);

	this.onSubScribeModal=this.onSubScribeModal.bind(this);
	
	this.showResetAlert = this.showResetAlert.bind(this);

	this.subtopic=this.props.subtopic;
	//this.subtopic.reqTestStatus=this.props.subtopic.reqTestStatus;
	//this.subtopic.testStatus=this.props.subtopic.testStatus;

  }
  componentDidMount(){
	  HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
  }

  handleMouseOver(event){	
	$(event.currentTarget).find(".hovertxt").show();
  }

  handleMouseOut(event){
	$(".hovertxt").hide();
  }
	
  onSubTopicStart(){	 
	 this.props.callbackParent(this.props.subtopic);
  }
  onSubTopicStartLessons(){	 
	 this.props.callbackParent(this.props.subtopic,"");
  }

  onSubScribeModal(){	 
	this.props.showSubscribe();
 }

  onSubTopicStartCP(){	 
	 this.props.callbackParent(this.props.subtopic,"CP");
  }
  onSubTopicStartPT(){	 
	 this.props.callbackParent(this.subtopic,"PT");
  }  

  getUserSubTopicPoints(){
  	if(this.subtopic && this.subtopic.userPoints){
  		return !isNaN(this.subtopic.userPoints) ? this.subtopic.userPoints : 0;
  	}

  	return 0;
  }

  getSubTopicPoints(){
  	 if(this.props.subtopic && this.props.subtopic.subTopicPoints){
  	 	return !isNaN(this.props.subtopic.subTopicPoints) ? this.props.subtopic.subTopicPoints : 0;
  	 }

  	 return 0;
  }

  getSubTopicUserGrade(){
  	if(this.props.subtopic && this.props.subtopic.grade){
  		return this.props.subtopic.grade;
  	}

  	return "";
  	//return this.rb("no_grade_available");
  }

  doReset(){
	var me = this;
	var testids = new Array();
	if(this.props.subtopic.testId){
		testids.push(this.props.subtopic.testId);
	}
	if(this.props.subtopic.recommendtestid){
		testids.push(this.props.subtopic.recommendtestid);
	}
	var topicsubtopicId=this.props.subtopic.topicsubtopicId;
	var params = {
	  "testId" : testids
	};
	var callBackSuccess = function(response){		
		//console.log("RESET_SUBTOPIC::",response);	
		if(response){
			if(response.response === "SUCCESS"){
				me.subtopic.status="NEW";
				me.subtopic.reqTestStatus="NEW";
				me.subtopic.testStatus="NEW";
				me.subtopic.userPoints=0;
				me.setState({noOfRetakesAvailable : me.state.noOfRetakesAvailable-1});
			}
		}
	}

	var callBackFailure = function(response){
		//console.log("Failure::: in RESET_SUBTOPIC");
	}
	var accessId = !isNaN(this.props.accessId) ? this.props.accessId : Number.parseInt(this.props.accessId);
	var classId = !isNaN(this.props.classId) ? this.props.classId : Number.parseInt(this.props.classId);
	var url=this.getUrlFor("RESET_SUBTOPIC")+"/"+topicsubtopicId+"/"+classId+"/"+accessId;
	new HmAjax(url).get(callBackSuccess,callBackFailure);	
  }
  showResetAlert(){
  		if(this.state.noOfRetakesAvailable <= 0){
		  this.showAlert(" ",this.rb("reset.noretakesmsg"));
		  return;
	  }
	  
	  var msg = this.rb("reset.msg");	 
	  confirmAlert({
		  customUI: ({ onClose }) => {
		    return (
		      <div className='custom-ui-alert'>
		        <div className="msg">{msg ? ReactHtmlParser(msg) : 'Hello..'}</div>
		        <br/>
		        <div className="msg greymsg">{this.rb("reset.retakesleft")}: <span className="msgcount">{this.state.noOfRetakesAvailable}</span></div>
		        <br/>
		        <div className="note text-left">{this.rb("reset.note")}</div>
		        <div>
			        <div className="col-6 btn alertbtn okbtn border-bottom-left-radius" onClick={() => {
			            this.doReset();
			            onClose();
			        }}> <i className="material-icons">done</i> {this.rb("alert.ok")}</div>
			        
			        <div className="col-6 btn alertbtn cancelbtn border-bottom-right-radius" onClick={onClose}> <i className="material-icons">close</i> {this.rb("alert.no")}</div>		        	
		        </div>
		        
		      </div>
		    )
		  }
		})
  }
  
  getBGImg(){
	  if(this.props.lessonOnlyMode == true){
		  	/*if(this.props.subtopic.status == "COMPLETED"){
				return <img src={completedTickImg} />
			}else{
				return <img src={LessonIconImg} />
			}*/
			//console.warn("this.props.subtopic ",this.props.subtopic);
			let lid = (this.props.subtopic && this.props.subtopic.lessonsSubTopicArr) ? this.props.subtopic.lessonsSubTopicArr[0].lessonurl : '';
			let wanttoShow = window.showSubTopicImageAsLessonImage || false;
			if(lid.trim().length>0 && wanttoShow) {		
				let backgroundImg = (this.getUrlFor("CS_BASE_URL")+imagePath+lid+"&type=lessons");
				return <img src={backgroundImg} />
			}
			else{		
				return <img src={LessonIconImg} />
			}
	  }else{
		  if(this.subtopic.status == "IN_PROGRESS"){			
				if(this.subtopic.reqTestStatus != "COMPLETED" && this.subtopic.testStatus == "COMPLETED"){	
					return <img src={practiceBgImg} />
				}else{
					return <img src={subtopicDefaultBgImg} />
				}
			}else if(this.subtopic.status == "COMPLETED"){
				return <img src={completedTickImg} />
			}else{
				return <img src={subtopicDefaultBgImg} />
			}
	  }
  }
  getStatusActionText(){	  
	  if(this.subtopic.status == "IN_PROGRESS"){
		  if(this.subtopic.testStatus == "COMPLETED" && this.subtopic.reqTestStatus != "COMPLETED"){
			  if(this.subtopic.reqTestStatus == "IN_PROGRESS"){
				  return this.rb("home.resume");	
			  }else{
				  return this.rb("home.start");
			  }
		  }
		  
		  return this.rb("home.resume");
			
		}else if(this.subtopic.status == "COMPLETED"){
			return "";
				
		}else{
			return this.rb("home.start");
		}
  }
  getDropDownItems(){
	  return (<div className="dropdown-menu">			
      <a className="dropdown-item" href="#"><i className="material-icons">star</i> {this.rb("home.markedquestions")}</a>			    	                      
      </div>)
  }
  getLesssonsActionLabel(){
	  	if(this.subtopic.status == "COMPLETED"){
	    	 return this.rb("lesson.watched");
	    }else if(this.subtopic.status == "IN_PROGRESS"){
	    	 return this.rb("home.resume");
	    }
		else{
	    	 return this.rb("home.start");
	    }
  }

	lockcontent(props){
		var classdisabled = "";	
		//console.log("abdul ",this.props.subtopic.practiceLocked)
		if(this.props.subtopic.practiceLocked){
			classdisabled = "disabled lockdisabledrecom1";
		}
		console.log("lock Content ",props)
		if(props){
			return (
				<a className={"col-6 card-bottom text-center nosidepadding notoppadding showcursor "+classdisabled} onClick={this.onSubScribeModal} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
							  <span className="upgrdlock2"><i class="material-icons">lock</i></span>
				  		    </div>
					  	</a>
				
			)
		}else{
			return (
				<a className="col-6 card-bottom text-center nosidepadding notoppadding showcursor" onClick={this.onSubTopicStartCP} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
							  <h5>
					{this.getStatusActionText()}
				</h5>
				  		    </div>
				</a>
				
			)
		}
	}
 
  getBottomItems(){
	  if(this.props.lessonOnlyMode == true){
		 
			  return (
						<div className="row clearfix bottomSection">				  
						  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartLessons} data-ga={"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - "+this.getLesssonsActionLabel()}>
							  	<a className="card-link tileLink">
							    	<h5>
					  		     
						  		    {(() => {				  		    	
						  		    	if(this.subtopic.status == "COMPLETED"){
					    		        	 return this.rb("lesson.watched");
					    		        }else if(this.subtopic.status == "IN_PROGRESS"){
					    		        	 return this.rb("home.resume");
					    		        }
						  		    	else{
					    		        	 return this.rb("home.start");
					    		        }
					    		      })()}
					  		    
					  		    </h5>
							     </a>
						  	</div>	    		    	
						</div>
				)
		 
	  }else{
		  if(this.subtopic.status == "IN_PROGRESS"){			
			if(this.subtopic.reqTestStatus != "COMPLETED" && this.subtopic.testStatus == "COMPLETED"){	
				return (					
		            
		            <div className="row clearfix bottomSection">	
					  	<a className="col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={"/scorecard/"+this.props.subtopic.testId} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
					  		<div className="card-link tileLink" ><img className="bottomReportsIcon" src={proficiencyReportIcon} /></div>
					  	</a>
						  {this.lockcontent(this.props.subtopic.practiceLocked)}
					  	{/* <a className={"col-6 card-bottom text-center nosidepadding notoppadding showcursor "+classdisabled} onClick={this.onSubTopicStartCP} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
						    	{
									this.lockcontent(this.props.subtopic.practiceLocked)
								}
				  		    </div>
					  	</a>	    		    	 */}
					</div>
	            )
			}else{
				return (
					<div className="row clearfix bottomSection">				  
					  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartPT} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()}>
						  	<div className="card-link tileLink">
						    	<h5>
						    	{this.getStatusActionText()}
						    	</h5>
						     </div>
					  	</div>	    		    	
					</div>
				)
			}
		  }else if(this.subtopic.status == "COMPLETED"){
			if(this.props.subtopic.recommendtestid != 0 && this.props.subtopic.recommendtestid != "0"){
				return (				
				        <div className="row clearfix bottomSection">	
						  	<a className="col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={"/scorecard/"+this.props.subtopic.testId} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
						  		<div className="card-link tileLink"><img className="bottomReportsIcon" src={proficiencyReportIcon} /></div>
						  	</a>
						  	<a className="col-6 card-bottom text-center nosidepadding notoppadding showcursor" href={"/scorecard/"+this.props.subtopic.recommendtestid} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - Report"}>
						  		<div className="card-link tileLink" >
								  <img className="bottomReportsIcon" src={practiceReportIcon} /></div>
						  	</a>	    		    	
						</div>
		        )
			}else{
				return (				
				        <div className="row clearfix bottomSection">	
						  	<a className="col-12 card-bottom text-center borderRight nosidepadding notoppadding showcursor" href={"/scorecard/"+this.props.subtopic.testId} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"}>
						  		<div className="card-link tileLink"><img className="bottomReportsIcon" src={proficiencyReportIcon} /></div>
						  	</a>					    		    	
						</div>
		        )
			}
		  }else{
			return (
					<div className="row clearfix bottomSection">				  
					  	<div className="col-12 card-bottom text-center nosidepadding showcursor" onClick={this.onSubTopicStartPT} data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()}>
						  	<a className="card-link tileLink">
						    	<h5>
				  		      {this.getStatusActionText()}
				  		    </h5>
						     </a>
					  	</div>	    		    	
					</div>
			)
		} 
	  }
  }
  getTestStatusName(){
	 if(this.subtopic.status == "IN_PROGRESS"){			
		if(this.subtopic.reqTestStatus != "COMPLETED" && this.subtopic.testStatus == "COMPLETED"){	
			return <div>{this.rb("home.practicetest")}</div>;			
		}else{
			return <div>{this.rb("home.proficiencytest")}</div>;	
		}
	}else if(this.subtopic.status == "COMPLETED"){
		return <div>{this.rb("home.reportcard")}</div>;	
	}else{
		return <div>{this.rb("home.proficiencytest")}</div>;	
	} 
  }
 
  getSelectedEmojiIcon(){	 
	  switch(this.state.selectedEmoji) {
		    case 5:		    	
		         return ( <img className="shakeme" src={ratingLoveitIconSmall} /> );
		        break;
		    case 4:
		         return ( <img className="shakeme" src={ratingGoodIconSmall} /> );
		        break;
		    case 3:
		         return ( <img className="shakeme" src={ratingNormalIconSmall} /> );
		        break;
		    case 2:
		         return ( <img className="shakeme" src={ratingBadIconSmall} /> );
		        break;
		    case 1:
		         return ( <img className="shakeme" src={ratingVerybadIconSmall} /> );
		        break;
		    default:
		        return ( <img src={ratingDefaultIcon} /> );
		}
  }
  saveRating(){
	  //console.log("subtopic:::",this.props.subtopic);
		var me = this;
		var ratingData = {
			"topicId" : this.props.subtopic.parentTopicId,
			"subTopicId" : this.props.subtopic.subTopicId,
			"classId" : parseInt(this.props.classId),
			"accessId" :parseInt(this.props.accessId),
			"rating" : parseInt(this.selectedRate)
		}
		
		var callBackSuccess = function(response){
			//console.log("response:::",response);
			me.props.subtopic.rating = parseInt(me.selectedRate);
		}

		var callBackFailure = function(error){
		//	console.log("Error in Ssubtopic RATING_EMOJI_SAVE");
		}

		new HmAjax(this.getUrlFor("RATING_EMOJI_SAVE"),ratingData).post(callBackSuccess,callBackFailure);	
		
		//----------------
		
		try{
			var trackObj = {
				"subtopic_id": this.props.subtopic.topicsubtopicId,
			    "rating": parseInt(this.selectedRate),
			    "grade_id": parseInt(this.props.classId),
			    "product_type": parseInt(this.props.accessId),
			    "source": this.getTracker().enums.itemRatedSource.home
			}			
	
			this.initiateTrack("item_rated",trackObj);
		}catch(e){}
  }
  getSubTopicBodyContent(){	
	  if(this.props.lessonOnlyMode == false){
		return(
				<div className="card-body info subtopicbody">
				
					{(() => {				  		    	
		  		    	if(this.subtopic.status == "COMPLETED"){
	    		        	return (
	    		        		<span className="resetContainer" style={{backgroundColor: this.props.subTopicBoxColor}} onClick={this.showResetAlert}>
									<i className="material-icons">replay</i>
								</span>
	    		        	);
	    		        }
					})()}
					
					<h5 className="card-title">{this.getTestStatusName()}</h5>
					
					<span className="card-link user-points">
						<img className="bottomPointsIcon" src={bottomPointsIcon} />
	      		    	<span className="user-points">{this.getUserSubTopicPoints()}</span>
	      		    	 / 
	      		    	<span className="points">{this.getSubTopicPoints()}</span>
	      		    </span>
	      		    
	      		    {(() => {				  		    	
		  		    	if(this.subtopic.status === "COMPLETED" || this.subtopic.reqTestStatus === "COMPLETED" || this.subtopic.testStatus === "COMPLETED"){
	    		        	return(
	    		        		<div>
		    		        		<div className="ratingemoji" onClick={this.toggle} id={'Popover-' + this.props.subtopic.testId}>
					      		    	{this.getSelectedEmojiIcon()}
					    		    </div>
					      		    <Popover className="emojiPopover subtopic" placement='top' isOpen={this.state.popoverOpen} target={'Popover-' + this.props.subtopic.testId} toggle={this.toggle}>
							          {/*<PopoverHeader>Popover Title</PopoverHeader>*/}
							          <PopoverBody className="pos_relative">	
							          		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={5} src={ratingLoveitIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Loved it</div></div>
							          		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={4} src={ratingGoodIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Good</div></div>
							          		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={3} src={ratingNormalIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Normal</div></div>
							          		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={2} src={ratingBadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Hard</div></div>
							          		<div className="emojianim" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><img className="emojiicons" data-rateindex={1} src={ratingVerybadIcon} onClick={this.selectRating} /><div className="text-center hovertxt">Very hard</div></div>						          		
							          </PopoverBody>
							        </Popover>
					      		</div>
	    		        	);
	    		        }
	    		    })()}
	      		    
	      		   
	      	  </div>    
		);
	  }
  }
  selectRating(event){
	  var target = event.currentTarget;
	  $(".emojiicons").removeClass("selected");
	  $(target).addClass("selected");
	  this.selectedRate = $(target).attr("data-rateindex");
	  this.setState({selectedEmoji:parseInt($(target).attr("data-rateindex"))});
	  this.saveRating();
	  this.toggle();
  }
  toggle() {
	  var me = this;
	  if(this.state.popoverOpen == false){
		  	 me.setState({
			      popoverOpen: !me.state.popoverOpen
			    });
	  }else{
		   me.setState({
		      popoverOpen: !me.state.popoverOpen
		    });
	  }
   
  }

  render() {
    return (  
    			 
                <div className="card subTopic clearfix">
		    		  <div className="card-img-top subtopic text-center" style={{backgroundColor: this.props.subTopicBoxColor}}>   
		    		  		 {this.getBGImg()}
		    		  </div>
		    		  <div className="card-img-overlay">
	    			    	<div className="card-title">{this.props.subtopic.subTopicName}</div>		    			    
	    			  </div>
	    			  {/*marked questions hidden -- kamaraj*/}
	    			  {/*<div className="heading-elements">
		    			  	
		    			  	<nav className="navbar fixed-top navbar-expand-md">
			    	            <ul className="navbar-nav mr-auto">			    	             
			    	                <li className="nav-item dropdown">
			    	                	<div className="float-right" data-toggle="dropdown"><i className="material-icons">more_vert</i></div>
			    	                	<div className="clearfix"></div>
			    	                    {this.getDropDownItems()}
			    	                </li>
			    	            </ul>
		    	            </nav>
		    	
		               </div>*/}
		               
		               {this.getSubTopicBodyContent()}		               		 
		    		 
			      	  {this.getBottomItems()}
	    		</div>
	    		
    );
  }
}

export default SubTopicComponent;



// WEBPACK FOOTER //
// ./src/views/plp/SubTopicComponent.js